import { useEffect, useState } from 'react';

// True while a phone's on-screen keyboard is up. There is no keyboard event on
// the web; the visual viewport shrinking well below the window is the signal
// (iOS Safari and Chrome on Android both report it). Desktop never trips it.
export function useKeyboardOpen() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    const check = () => setOpen(vv.height < window.innerHeight * 0.75);
    vv.addEventListener('resize', check);
    return () => vv.removeEventListener('resize', check);
  }, []);
  return open;
}

const FIELD = 'input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=file]):not([disabled]), textarea:not([disabled]), select:not([disabled])';

function fieldsIn(root) {
  return Array.from(root.querySelectorAll(FIELD)).filter((el) => el.offsetParent !== null);
}

// Typing on a phone, one field after another: the return key says Next (or Done
// on the last field) and moves on, and whichever field gets focus is scrolled to
// the middle of the space the keyboard leaves. Wired once on the container, so
// every patient screen gets it without touching its fields.
export function keyboardFlowHandlers(rootRef) {
  return {
    onFocus: (e) => {
      const el = e.target;
      if (!el.matches || !el.matches(FIELD) || !rootRef.current) return;
      const list = fieldsIn(rootRef.current);
      if (el.tagName !== 'TEXTAREA') el.enterKeyHint = list.indexOf(el) < list.length - 1 ? 'next' : 'done';
      // After the keyboard has finished sliding up, so "middle" is the middle
      // of what is actually visible.
      setTimeout(() => el.scrollIntoView({ block: 'center', behavior: 'smooth' }), 300);
    },
    onKeyDown: (e) => {
      const el = e.target;
      if (e.key !== 'Enter' || el.tagName !== 'INPUT' || !rootRef.current) return;
      const list = fieldsIn(rootRef.current);
      const nextEl = list[list.indexOf(el) + 1];
      e.preventDefault();
      if (nextEl) nextEl.focus();
      else el.blur(); // keyboard down, the Continue bar comes back
    },
  };
}
